<div class="wrapper">
    <header class="s7-page-header">
        <div class="header-col col-auto header-col-hamburger">
            <span class="d-lg-none pointer" (click)="toggleMobileMenu()" *ngIf="isAuthorized">
                <svg class="icon-32"><use xlink:href="images/s7-icons-32.svg#menu" /></svg>
            </span>
        </div>

        <div class="s7-page-logo">
            <a class="logo-image" [class.logo-image-bp-ru]="currentLanguage === 'RU'" [class.logo-image-bp-en]="currentLanguage !== 'RU'" [href]="vsmPortalUrl">
            </a>
        </div>

        <div class="flex-grow-1"></div>
        <div class="s7-page-user-info">
            <div *ngIf="isAuthorized" #userDrop="ngbDropdown" ngbDropdown class="d-flex" placement="bottom-right">
                <button id="dropDownUserInfo" class="s7-page-user-info-login btn-link btn-link-with-icon btn-link-additional" ngbDropdownToggle>
                    <img src="dist/user-icon.svg" class="mr-12" />
                    <div class="header-item-sm-none">{{ userName }}</div>
                    <svg class="btn-icon-right icon-20-chevron-down header-item-sm-none" [class.up]="userDrop.isOpen()">
                        <use xlink:href="images/s7-icons-20.svg#chevron-down" />
                    </svg>
                </button>

                <div ngbDropdownMenu aria-labelledby="dropDownUserInfo" class="s7-dropdown-menu">
                    <button class="s7-dropdown-item header-item-lg-none" ngbDropdownItem>{{ userName }}</button>
                    <a class="s7-dropdown-item" ngbDropdownItem href="home/logout">
                        {{ 'shared:layout.logoutLinkTitle' | i18next }}
                    </a>
                </div>
            </div>

            <div *ngIf="!isAuthorized">
                <div class="anonymous-wrapper header-item-sm-none mr-12">
                    <span class="mr-12 icon icon-logo-s-7"></span>
                    <a data-cy-logout class="link header-user-name anonymous-link" [href]="loginFromAnonymousPageUrl | async">{{
                        'shared:layout.anonymousLoginPage' | i18next
                    }}</a>
                </div>

                <div #userDrop="ngbDropdown" ngbDropdown class="header-item-lg-none" placement="bottom-right">
                    <button id="dropDownUserInfo" class="s7-page-user-info-login btn-link btn-link-with-icon btn-link-additional " ngbDropdownToggle>
                        <img src="dist/user-icon.svg" class="mr-12" />
                    </button>

                    <div ngbDropdownMenu aria-labelledby="dropDownUserInfo" class="s7-dropdown-menu">
                        <a class="s7-dropdown-item" ngbDropdownItem [href]="loginFromAnonymousPageUrl | async">
                            {{ 'shared:layout.anonymousLoginPage' | i18next }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div ngbDropdown placement="bottom-right" class="s7-page-lang-icon">
            <button id="langIcon" ngbDropdownToggle class="btn-link btn-link-with-icon btn-link-additional">
                <img *ngIf="currentLanguage === 'RU'" src="dist/russian-flag.svg" />

                <img *ngIf="currentLanguage === 'EN'" src="dist/english-flag.svg" />
            </button>
            <div ngbDropdownMenu aria-labelledby="langIcon" class="s7-dropdown-menu">
                <button (click)="setLocale('ru')" class="s7-dropdown-item-with-icon" ngbDropdownItem>
                    <img src="dist/russian-flag.svg" class="mr-12" />
                    Русский
                </button>
                <button (click)="setLocale('en')" class="s7-dropdown-item-with-icon" ngbDropdownItem>
                    <img src="dist/english-flag.svg" class="mr-12" />
                    English
                </button>
            </div>
        </div>
        <div class="s7-page-oneworld-icon">
            <a href="https://www.oneworld.com/" class="" target="_blank">
                <img class="icon-32" src="images/custom/oneworld-32.svg" alt="file" />
            </a>
        </div>
    </header>
</div>

<div class="header-navigation" ngbDropdown #menuDropdown="ngbDropdown" autoClose="outside" [class.menu-dropdown-hide]="!isAuthorized">
    <div class="header-navigation-wrapper">
        <div class="s7-container">
            <div class="header-navigation-item" *ngFor="let item of navigationItems">
                <span
                    class="header-navigation-item-link no-dropdown-arrow"
                    [class.header-navigation-item-link-active]="activeNavigationItem === item && dropdown.isOpen()"
                    (click)="setActiveNavigationItem(item)"
                    ngbDropdownToggle
                    >{{ item.title }}</span
                >
            </div>
        </div>
    </div>
    <div ngbDropdownMenu class="header-navigation-dropdown" >
        <div class="s7-container header-navigation-dropdown-container">
            <div class="header-navigation-dropdown-title">{{ activeNavigationItem?.title }}</div>
            <div class="header-navigation-dropdown-content">
                <div class="header-navigation-dropdown-col" *ngFor="let menuItem of activeNavigationItem?.items">
                    <div class="header-navigation-dropdown-header">{{ menuItem.title }}</div>
                    <div class="header-navigation-dropdown-item" *ngFor="let subitem of menuItem.items">
                        <a
                            [href]="subitem.url"
                            (click)="trackOutboundTransitionFromMenu(subitem.title)"
                            [target]="subitem.openInNewWindow ? '_blank' : '_self'"
                            class="header-navigation-dropdown-link"
                            >{{ subitem.title }}</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
